export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";

// token - test
//export const TOKEN = "UcPpVZOIxJb4Z/uEFMakFUgUUxcejUVGjfVK3NQ6rs4=";

// Token - pro
export const TOKEN = process.env.VUE_APP_TOKEN; // "Mx8ebocPk+1GIkJ3gl0BL0Jjbq3vVB8dQkfMzmxhJBk=";
export const SECRET_API_KEY = process.env.VUE_APP_SECRET_KEY; // "199a71af8f299dc8d705d2c407dbec54";
export const MINIAPP_ID = process.env.VUE_APP_MINIAPP_ID; // "app-ac0cce36-05a2-488b-b308-630a2113d333";
export const PUBLIC_KEY =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoPumOUdivGiw4qN5AVzGiJwabKFABpNMQ/wY71d+PSihkRwohRGl8zkmQ/5hu2hCM65eT0SS9buySpcrR6iIFpgL3SpeX4gMhRwQr6OIMQpR7JnRNrDPeg2igeDrfEl9fnfenOyqUfhhZzFXnwYtQs6Kilhqk2I9hmn1b5qxJ3L6RJKJsSnhQ8eEKdU3h1Bgj+cV5w1sadgN31KmQhbgFhld65QSE96cDAgDdjU/CzfXe4CimjlK0uJpephWpJagZDHRhsTRuDADYfmx/w67CjWvMxsGIbjgYFGuGCbnIUsxyqhAEQPJoH8iSSvinPNVJkSyRl3ivb6KdDRRQxC0owIDAQAB";
export const PRIVATE_KEY =
  "MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCf5S/qdJ/Xf34IJ2SCfLHOGmAQU7qB3y2zLXzSSxJbVy0KBw9QhL+qUvUF6IARS1P8GIbZeFGooRtkvOU3mAWMh9PQQTCrLNg0vUzNgF95k0aJw8FyUEeAgR96DAfHNfYnsZ2d7F3X75bI1LmMY1do3ajZxYrMQW+UxKY/wh5qJ/ZGpuJtWHI63KdcaHJEkuTMOhMXpmOQmpCimD8bU7/qHNSZpB5Q5T9je6u3ilBEcENU5nN/Id57GKNUxAZ3Gb8JK8s5Kv8TRkjMhXZ9FrJex738smlK+CcotXN9NSCDyYyVxe1HP++Med+nmBTPOZgXDorRSpgftNKz44QFZiUvAgMBAAECggEAJyznDYGffBQfk+3a4WGdysqJiNaK1rEQqFrXv0pnZ/u27EMIjIjJ0PhcUiNB5XrYS+bSe0vQbglzBb6GRpW3nlPVIKwoOXhWTK2ouJzgR5A+8xgEOHbU3fZE+Qkjirp84gLRhFTaNULdZb1A7NWWH/pXGWwd8qeBqCh6NxrfitB2DiyFPm9ksVF4mpYseX+/vnVuOX7Y2zV8DAcDhI5LN5nf/29YcPs1qlZfA4hjzvVySOHbYJLFzzL4ijUtHNQKBpWt0WDLxg8wcEJbbjs6lvVlwTk1qJnIX3gSBQTeZEetEo8p0QetZ4I/C/TFiOjOxmZzYhmd6OqpWR6Ag9JhCQKBgQDf+3qUmxXlKIrk1Wnrm6Gu5M4O1CS2w/nYbMquWnEFeBQTi83PoWwyKICF8ASzJOi5iKRNsbxd+9nCHXiGhwO9MWLVr24CKhLrKtEebG1twN2szy6RGf2Ucn8FpxmIe9DBSZqKQ4LtviJWhrfaGJ+pgxbwu1sSlgyfwREJWpY5JQKBgQC2wHlVutheBxvTREqbIt9Nbs8PlaUQNE0PvwJcUricJ7CH5Ins6qCxLnsiTifk6Ot/jp6lX3tOX0BJcyZ1ZjkBPjmLKgFl1eDJuCv0cUxiwzCSkBu8vXqtWU30E6JnLcWongi4YyqcEcmJYVpk75vVj07k9k3nvUWiSI0Zpc7GwwKBgQCHdVyOETjtrVZKzLLRVf8zeZcRKsXFbsJkXG87gOEHkLZ7l7pxzstTjmEkH6OIAFNrGbNcdZhZMp5golgo6/Cb9Ak0+HLMhkuIxA1Sm/qWPOUTxP0BrjlJFPGzJnrvqwn2S6BV7Dx7sdisga8hDHFLIEe4cWbD19FssGOwR4PArQKBgDcgXjlvED9k047qBbtATK215D3mPRFjRW+fhZ3F0ixAiK6lULmnmOt5guk5PC1/2TH0GoT2BWMBtomxc4NsX3uxgngpJpzKZHFU3eVxm8Ia8Pb1A3juiyfpTWt31MBc/Ue8zBKaz0qezvVi6XqTEKXeAcVtStjBrlSin/WBn5szAoGACceaNiqS2dMnxoJOoeYM0Jd+XnV40gEtDHo3q1DgTCtkfgiMrN+M/AZ7WrVq8Ubvaqs89NuxeUXg5M63Xu71uvfnwJXbRsE+mZcYujAdxwDnIb5w84fP4N1MrB2T1k/6+fVSls7iiPFx3rSj7uWV2SFQxljmld1XjVSHFr8YhRQ=";

export const color_primary = "#C41627";
export const Locales = [
  {
    code: "en",
    name: "en_US",
    forward: "en",
  },
  {
    code: "kh",
    name: "kh_KH",
    forward: "kh",
  },
  {
    code: "zh",
    name: "en_US",
    forward: "en",
  },
];

export const CONSTANTS = {
  SUCCESS,
  ERROR,
  TOKEN,
  SECRET_API_KEY,
  MINIAPP_ID,
  Locales,
  PRIVATE_KEY,
  PUBLIC_KEY,
  color_primary,
};
